import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  DynamicTable,
  ArrayHelper,
  DynamicTableHelper,
  TooltipWrapper,
  DateHelper,
} from "@workspace/common";
import { useSelector } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import {
  REPORT_INITIAL_OPTIONS,
  generateJobReportFields,
  REPORT_MANDATORY_OPTIONS,
} from "./ReportJobConstants";
import { FilterBubbles } from "@workspace/common";
import {
  setJobDefaultCustomView,
  editReportCustomViewById,
} from "../../../store/report/action";
import { getJobReportJobListing } from "../../../helpers/backend_helper";
import { JOB_TYPE, checkFODRTypes } from "../UniversalReportConstant";
import "./DynamicTableWrapper.scss";

function DynamicTableWrapper({
  data,
  pageInfo,
  pageRequest,
  pageRequestSet,
  config,
  search,
  setSearch,
  optGroup,
  setCustomConfigData,
  header,
  activeRow,
  setActiveRow,
  setTableConfig,
  jobStep,
  setIsReportOffcanvasOpen,
  isReportOffcanvasOpen,
  ...props
}) {
  // ================== Custom Render ==================
  const customRenderList = [
    {
      names: ["updatedAt", "createdAt"],
      render: (data, opt) =>
        DateHelper.formatDateStandard2(
          DynamicTableHelper.getDynamicNestedResultForExport(data, opt?.name) ||
            ""
        ),
    },
  ];
  // ===================================================
  // Dispatch
  const dispatch = useDispatch();

  const jobUniversalReportJobListingMeta = useSelector(
    (state) => state?.ReportReducer?.jobUniversalReportJobListingMeta
  );

  const jobReportCustomViews = useSelector(
    (state) => state?.ReportReducer?.jobReportCustomViews
  );

  const defaultCustomView = useSelector(
    (state) => state?.ReportReducer?.jobDefaultCustomView
  );

  const timelineDefaultCustomView = useSelector(
    (state) => state?.ReportReducer?.defaultCustomView
  );

  const jobForm = useSelector((state) => state.JobFormReducer.form);

  const handleClose = () => {
    setIsReportOffcanvasOpen(false);
  };

  useEffect(() => {
    if (!isReportOffcanvasOpen) {
      pageRequestSet.setPage(0);
      pageRequestSet.setPageSize(50);
    }
  }, [isReportOffcanvasOpen]);

  useEffect(() => {
    if (jobReportCustomViews != null && jobReportCustomViews.length > 0) {
      const selectedCustomView = jobReportCustomViews?.find(
        (customView) => customView?.selected
      );
      if (selectedCustomView) {
        const selectedGroup = selectedCustomView?.columnName?.split(",");
        const selectedObjects = selectedGroup?.map((value) => {
          return generateJobReportFields(jobForm)?.find(
            (option) => option?.value === value
          );
        });
        if (selectedObjects.length > 0) {
          setCustomConfigData(selectedObjects);
        }
        pageRequestSet.setFilterData(selectedCustomView?.filters);
        pageRequestSet.setExternalFilterData(
          props?.timelineCustomView?.externalFilters ||
            timelineDefaultCustomView?.externalFilters ||
            []
        );
      } else if (!selectedCustomView) {
        if (
          defaultCustomView?.columnName &&
          defaultCustomView?.columnName?.length > 0
        ) {
          const selectedObjects = defaultCustomView?.columnName?.map(
            (value) => {
              return generateJobReportFields(jobForm)?.find(
                (option) => option?.value === value
              );
            }
          );
          setCustomConfigData(selectedObjects);
        } else {
          setCustomConfigData(REPORT_INITIAL_OPTIONS);
        }

        pageRequestSet.setFilterData(defaultCustomView?.filters ?? []);
        pageRequestSet.setExternalFilterData(
          props?.timelineCustomView?.externalFilters ||
            timelineDefaultCustomView?.externalFilters ||
            []
        );
      }
    }

    if (jobReportCustomViews != null && jobReportCustomViews.length === 0) {
      if (
        defaultCustomView?.columnName &&
        defaultCustomView?.columnName?.length > 0
      ) {
        const selectedObjects = defaultCustomView?.columnName?.map((value) => {
          return generateJobReportFields(jobForm)?.find(
            (option) => option?.value === value
          );
        });
        setCustomConfigData(selectedObjects);
      } else {
        setCustomConfigData(REPORT_INITIAL_OPTIONS);
      }
      pageRequestSet.setFilterData(defaultCustomView?.filters ?? []);
      pageRequestSet.setExternalFilterData(
        props?.timelineCustomView?.externalFilters ||
          timelineDefaultCustomView?.externalFilters ||
          []
      );
    }
  }, [
    jobReportCustomViews,
    jobForm,
    defaultCustomView,
    timelineDefaultCustomView,
    props?.timelineCustomView,
  ]);

  const handleSetDefaultCustomView = (defaultCustomView, newFilters) => {
    dispatch(
      setJobDefaultCustomView({ ...defaultCustomView, filters: newFilters })
    );
  };

  const handleEditCustomViewById = (customView, newFilters) => {
    dispatch(
      editReportCustomViewById({
        editId: customView.id,
        payload: {
          ...customView,
          columnName: ArrayHelper.convertCommaSeperatedToArray(
            customView?.columnName
          ),
          filters: newFilters,
        },
      })
    );
  };

  // Export Excel
  const handleEportExcel = async () => {
    let exportData = null;
    try {
      const payload = {
        ...pageRequest,
        jobType: jobStep,
        isDownload: true,
        filters: props?.jobBubbleExternalFilter,
      };
      const resp = await getJobReportJobListing(payload);
      exportData = resp?.data?.jobs;
      if (activeRow?.length > 0) {
        if (checkFODRTypes(jobStep)) {
          exportData = exportData.filter((item, index) => {
            return activeRow.includes(index);
          });
        } else {
          exportData = exportData.filter((item) =>
            activeRow.includes(item?.id)
          );
        }
      }
    } catch (e) {}

    DynamicTableHelper.handleExportExcel(
      `Job Report - (${jobStep})`,
      exportData,
      config.slice(2),
      customRenderList,
      true
    );
  };

  return (
    <div>
      <Row style={{ borderBottom: "1px solid lightgray" }}>
        <Col lg={12}>
          <div className="d-flex flex-column align-items-start mb-1">
            <div className="d-flex flex-row justify-content-between align-items-center w-100 mb-1">
              <div className="d-flex flex-row gap-3 align-items-center justify-content-center ">
                <div className="fw-semibold fs-5">
                  {props?.tableTitle}{" "}
                  {jobUniversalReportJobListingMeta?.isLoading
                    ? " (0)"
                    : ` (${pageInfo?.totalElements || 0})`}
                </div>
                <div className="search-box">
                  {setSearch && (
                    <form onSubmit={pageRequestSet.setSearchTerm}>
                      <input
                        type="text"
                        placeholder="Search.."
                        className="form-control search border-light"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <span className="mdi mdi-magnify search-icon"></span>
                    </form>
                  )}
                </div>
              </div>
              <div className="d-flex flex-row gap-3 align-items-center justify-content-center ">
                <TableItemDisplay
                  pageInfo={pageInfo}
                  isLoading={jobUniversalReportJobListingMeta?.isLoading}
                />
                <div
                  style={{
                    width: "2px",
                    height: "20px",
                    backgroundColor: "#adb5bd",
                    marginLeft: "12px",
                  }}
                ></div>
                <TableRowsPerPageWithNav
                  pageInfo={pageInfo}
                  pageRequestSet={pageRequestSet}
                />
                <TooltipWrapper tooltipText="Export to Excel">
                  <Button
                    color="light"
                    className="report-listing-filter-btn  fw-bold d-flex flex-row align-items-center px-1 justify-content-center"
                    onClick={handleEportExcel}
                    style={{
                      height: "25px",
                      width: "28px",
                    }}
                  >
                    <i
                      className="ri-download-fill align-bottom"
                      style={{
                        fontSize: "12px",
                      }}
                    ></i>
                  </Button>
                </TooltipWrapper>
                <span
                  className="mdi mdi-close cursor-pointer"
                  onClick={handleClose}
                ></span>
              </div>
            </div>
            <FilterBubbles
              setBubbleExternalFilter={props?.setJobBubbleExternalFilter}
              bubbleExternalFilter={props?.jobBubbleExternalFilter}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={12} className="report-oc-wrapper">
          {jobStep !== "" ? (
            <DynamicTable
              config={config}
              data={data}
              pageRequestSet={pageRequestSet}
              pageInfo={pageInfo}
              isLoading={jobUniversalReportJobListingMeta?.isLoading ?? true}
              freezeHeader={true}
              activeRow={activeRow}
              setTableConfig={setTableConfig}
              pageRequest={pageRequest}
              tableHeight="100%"
              isActiveRowIndex={checkFODRTypes(jobStep)}
            />
          ) : (
            <div className="mt-3">
              <span className="form-text">
                Data is currently not available.
              </span>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default DynamicTableWrapper;
